module.exports = __webpack_public_path__ + "static/media/icon_instrument_violin.ac5a3601.svg";